// ActionButton.js
import React from 'react';
import PropTypes from 'prop-types'; // Recommended for type checking in plain JavaScript/React

/**
 * @typedef {Object} ActionButtonProps
 * @property {string} label - The text displayed inside the button.
 * @property {() => void} onClick - The function to be executed when the button is clicked.
 * @property {'edit' | 'delete' | 'view'} [type='edit'] - Optional: Defines the type of action. Currently unused in styling but useful for semantics/future styling.
 */

/**
 * A reusable button component for various actions (edit, view, delete, etc.).
 * It uses CSS variables for styling and provides hover effects.
 *
 * @param {ActionButtonProps} props - The component props.
 * @returns {JSX.Element} The rendered button component.
 */
const ActionButton = ({ label, onClick, type = 'edit' }) => {

    return (
        <button
            className={`
                bg-[var(--grey-button)] 
                hover:bg-[var(--primary-text-color)] 
                hover:text-white 
                text-var(--primary-text-color) 
                px-3 py-1 
                rounded-xl 
                text-xs 
                cursor-pointer
            `}
            onClick={onClick}
        >
            {label}
        </button>
    );
};

export default ActionButton;